<template>
  <div class="logo">
    <div class="test bg-it-primary"></div>
    <span class="pl-2 text-it-primary">ALUMNI</span>
  </div>
</template>
<script>
export default {
  name: "BaseFormLogo"
}
</script>
<style lang="postcss" scoped>
.logo {
  @apply tw-flex tw-justify-center tw-pt-2 tw-pb-8;
  font-size: 24px;
  & > div {
    width: 30px;
    height: 30px;
    mask: url(https://static.educacionit.com/alumni/assets/generic/logo.svg) center / 30px no-repeat;
  }
  & img {
    width: 35px;
  }
}
</style>
